<template>
  <div id="blogs">
    <aside id="catelog">
      <h3>博客目录</h3>
      <ul>
        <li v-for="article in catelog" @click="toArticle(article)">{{article}}</li>
      </ul>
    </aside>
    <div>
      <h2 class="article-name">{{article}}</h2>
      <vue-markdown :source=articalTxt class="markdown-body"/>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'

export default {
  name: 'blog',
  components: {
    VueMarkdown
  },
  data(){
    return {
      article: 'window-onload-和-document-onDOMContentLoaded-有什么区别？',
      articalTxt: '',
      catelog: [ 
      'window-onload-和-document-onDOMContentLoaded-有什么区别？',
      'JS中元素高度相关方法',
      'JS数组终极神器Array-splice',
      'jQuery事件绑定原理',
      'jQuery动画方法',
      'JavaScript作用域链',
      'if和==到底是怎么判断的？',
      'Git中的后悔药：reset-&-revert',
      'Git基本使用笔记（一）',
      'Git基本使用笔记（二）',
      'GET和POST的区别',
      'DOM事件模型还分级？',
      'CSS中的文字排版',
      'CSS中常见的长度单位',
      'BFC？浏览器兼容？',
      '移动端问题汇总帖',
      '前端mock简介',
      '举例说明ES5中Array的新方法',
      '简述CSRF',
      '简述跨域',
      '简单块级元素和行内元素的区别',
      '关于CSS属性继承',
      '浮动&定位',
      '从IIFE提一下事件循环',
      '常见的浏览器内核'
      ]
    }
  },
  mounted(){
    if(!this.article || this.article == '') {
      this.article = this.catelog[0]
    }
    this.getArticle()
  },
  methods: {
    toArticle: function(str) {
      this.article = str
      this.getArticle()
    },
    getArticle: function() {
      this.axios.get('static/blog/'+this.article+'.md').then(response => {
        this.articalTxt = response.data
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="sass">
  #blogs 
    padding: 10px
    display: flex
    h2.article-name
      font-size: 1.6em
      padding: .4em 0
      margin: 0.83em 0 1.2em
      border-bottom: 1px solid #dadcdf
    aside
      width: 290px
      margin-right: 10px
      flex: 0 0 auto
      ul 
        li
          line-height: 1.4em
          padding: 5px 7px
          cursor: pointer
        li:hover
          background: #efefef
</style>


// WEBPACK FOOTER //
// src/components/Blog.vue